export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14073.eb72970c.jpg";